<div class="text-center py-3" *ngIf="loading">
    <app-spinner
        type="pulse"
        size="large"
    ></app-spinner>
</div>
<div *ngIf="!loading">
    <ng-content></ng-content>
</div>
